import { NgModule } from '@angular/core';
import {
    NavbarModule,
    PopModule,
    IconModule,
    ModalModule,
    ButtonModule,
    ProgressIndicatorsModule,
    TabsModule,
    TableModule,
    SearchBarModule,
    SortModule,
    PaginationModule,
    FormFieldModule,
    RadioButtonModule,
    InputModule,
    MultiselectModule,
    ToasterModule,
    SlideToggleModule,
    TileModule,
    ScrollNavModule,
    SelectModule,
    FileUploaderModule,
    CheckboxModule,
    EllipsisPipeModule,
    SidenavModule,
    DatepickerModule,
    HcNativeDateModule,
    DateRangeModule,
    ListModule
} from '@healthcatalyst/cashmere';

@NgModule({
    exports: [
        NavbarModule,
        PopModule,
        IconModule,
        ModalModule,
        ButtonModule,
        ProgressIndicatorsModule,
        TabsModule,
        TableModule,
        SearchBarModule,
        SortModule,
        PaginationModule,
        FormFieldModule,
        RadioButtonModule,
        InputModule,
        MultiselectModule,
        ToasterModule,
        SlideToggleModule,
        TileModule,
        ScrollNavModule,
        SelectModule,
        FileUploaderModule,
        CheckboxModule,
        EllipsisPipeModule,
        SidenavModule,
        DatepickerModule,
        HcNativeDateModule,
        DateRangeModule,
        ListModule
    ]
})
export class CashmereModule {}
